import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Super Admin API
export const SuperAdminAPI = axios.create({
  baseURL: `${BACKEND_URL}/api/super-admin`,
});

SuperAdminAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('super_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

SuperAdminAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && !url.includes('/login') && !url.includes('/forgot-mpin') && !url.includes('/reset-mpin') && !url.includes('/google-auth')) {
      localStorage.removeItem('super_admin_token');
      window.location.href = '/super-admin';
    }
    return Promise.reject(error);
  }
);

// Super Admin B2B API (for accessing /api/b2b endpoints with super admin token)
export const SuperAdminB2BAPI = axios.create({
  baseURL: `${BACKEND_URL}/api/b2b`,
});

SuperAdminB2BAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('super_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

SuperAdminB2BAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('super_admin_token');
      window.location.href = '/super-admin';
    }
    return Promise.reject(error);
  }
);

// Vendor API
export const VendorAPI = axios.create({
  baseURL: `${BACKEND_URL}/api/b2b`,
});

VendorAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('vendor_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

VendorAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && !url.includes('/login') && !url.includes('/forgot-mpin') && !url.includes('/reset-mpin') && !url.includes('/google-auth')) {
      localStorage.removeItem('vendor_token');
      window.location.href = '/vendor';
    }
    return Promise.reject(error);
  }
);

// B2B API for doctors (uses existing clinic token)
export const B2BAPI = axios.create({
  baseURL: `${BACKEND_URL}/api/b2b`,
});

B2BAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('clinic_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default { SuperAdminAPI, SuperAdminB2BAPI, VendorAPI, B2BAPI };
